import { render } from "./BathCreate.vue?vue&type=template&id=8a4d98e6"
import script from "./BathCreate.vue?vue&type=script&lang=js"
export * from "./BathCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__